import React, { useContext } from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { useOktaAuth } from '@okta/okta-react';

import { StaleSessionContext } from '../StaleSessionContext/StaleSessionContext';

const StaleSessionDialog = () => {
  const { isSessionStale } = useContext(StaleSessionContext);
  const { oktaAuth } = useOktaAuth();

  const handleLogInAgain = () => {
    oktaAuth.signInWithRedirect({ originalUri: window.location.href });
  };

  return (
    <Dialog open={isSessionStale} aria-labelledby="stale-session-dialog-title">
      <DialogTitle id="stale-session-dialog-title">Session Expired</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Your session has expired. Please log in again to continue.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleLogInAgain}>Log In Again</Button>
      </DialogActions>
    </Dialog>
  );
};

export default StaleSessionDialog;
